export Component from './components/Component';
export Bar from './components/Bar';
export Search from './components/Search';
export Container from './components/Container';
export AffixSearch from './components/AffixSearch';



/** WEBPACK FOOTER **
 ** ./src/app/modules/header/index.js
 **/